import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import logoWhite from "@/assets/logo-white.webp";

const WEBSTORE_URL = "https://avoinna24.fi/takomo/join/member";

export default function HeroSection() {
  return (
    <section className="relative min-h-[calc(100vh-4rem)] md:min-h-[calc(100vh-5rem)] w-full overflow-hidden flex items-center justify-center">
      {/* Video Background */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
        src="/videos/hero.mp4"
      />

      {/* Overlay */}
      <div
        className="absolute inset-0"
        style={{ background: "var(--hero-overlay)" }}
      />

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-4xl">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="font-display text-foreground/80 tracking-[0.3em] text-sm md:text-base mb-6"
        >
          JOKELA & KELLOKOSKI
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mb-8"
        >
          <img
            src={logoWhite}
            alt="Takomo Kuntosali"
            width={640}
            height={207}
            fetchPriority="high"
            className="mx-auto w-[360px] md:w-[500px] lg:w-[640px]"
          />
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
          className="text-foreground/70 text-lg md:text-xl max-w-2xl mx-auto mb-10 font-body"
        >
          Kaksi laadukasta kuntosalia aivan Jokelan ja Kellokosken keskustassa. - Molempiin kulku samalla kortilla!
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.9 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <Link
            to="/hinnasto#webstore"
            className="btn-primary-premium px-8 py-4 rounded text-base"
          >
            Liity jäseneksi
          </Link>
          <Link
            to="/hinnasto"
            className="btn-outline-premium px-8 py-4 rounded text-base"
          >
            Katso hinnasto
          </Link>
        </motion.div>
      </div>


    </section>
  );
}
